<template lang="html">
  <v-tooltip bottom class="Status__Icon">
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        v-bind:style="{color: corStatus}">lens</v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    tooltip: String,
    color: String,
    colorPalette: {
      type: Array,
      default() {
        return [
          '#e67e22', // Laranja
          '#f1c40f', // Amarelo
          '#1E88E5', // Azul
          '#e74c3c', // Vermelho
          '#1abc9c', // Verde
          '#95a5a6', // Cinza
          '#1E88E5', // Azul
          '#7e57c2', // Roxo
        ];
      },
    },
    status: {
      type: String,
      default: 'EM_PROSPECCAO',
    },
  },
  computed: {
    corStatus() {
      let colorIndex = 0;
      if (this.status === 'EM_PROSPECCAO' || this.status === 'MANUTENCAO_AGUARDANDO_APROVACAO') {
        colorIndex = 0;
      } else if (this.status === 'EM_EXECUCAO') {
        colorIndex = 1;
      } else if (this.status === 'CONCLUIDA' || this.status === 'MANUTENCAO_CONCLUIDA') {
        colorIndex = 4;
      } else if (this.status === 'INATIVA') {
        colorIndex = 3;
      } else if (this.status === 'AGUARDANDO_APROVACAO' || this.status === 'AGUARDANDO_INATIVACAO') {
        colorIndex = 6;
      } else if (this.status === 'REPROVADA' || this.status === 'EM_MANUTENCAO') {
        colorIndex = 5;
      } else {
        colorIndex = 0;
      }
      return this.color || this.colorPalette[colorIndex];
    },
  },
};
</script>
